<div class="container">
  <h1 class="title">{{ introMessage ? introMessage : ('APPLICATION_START.TITLE' | translate) }}</h1>
  <p class="notification" *ngIf="introMainMessage">{{ introMainMessage }}</p>
  <p class="notification" *ngIf="!introMainMessage">{{ ('APPLICATION_START.CONTENT.FIRST_PASSAGE' | translate) + '\n\n' + ('APPLICATION_START.CONTENT.SECOND_PASSAGE' | translate) }}</p>
  <button (click)="startJobApplication()"
          class="btn-secondary">{{ 'BUTTONS.START' | translate }}</button>
</div>
